import React from 'react';
import { graphql } from 'react-relay';
import { useLazyLoadQuery } from 'react-relay/hooks';
import Balance_balance, { Balance_balance$key } from './__generated__/Balance_balance.graphql';
import useLiveFragment from '../../../relay/useLiveFragment';
import { BalanceQuery } from './__generated__/BalanceQuery.graphql';

export interface Props {
  balanceRef: Balance_balance$key;
}

const fragmentSpec = graphql`
  fragment Balance_balance on Balance @refetchable(queryName: "BalanceRefetchQuery") {
    id
    amount {
      formatted
    }
  }
`;

export const FragmentedBalance: React.FC<Props> = ({ balanceRef }) => {
  const balance = useLiveFragment(fragmentSpec, balanceRef);

  return <>{balance.amount.formatted}</>;
};

const query = graphql`
  query BalanceQuery {
    balance {
      ...Balance_balance
    }
  }
`;

const BalanceContainer: React.FC<{}> = () => {
  const data = useLazyLoadQuery<BalanceQuery>(
    query,
    {},
    {
      fetchPolicy: 'store-or-network',
    },
  );
  return <FragmentedBalance balanceRef={data.balance!} />;
};

export default BalanceContainer;
